import type { ReactNode } from "react";

import { cn } from "../lib/cn";

export interface FieldProps {
  label: ReactNode;
  children: ReactNode;
  htmlFor?: string;
  required?: boolean;
  hint?: ReactNode;
  error?: ReactNode;
  className?: string;
  /** Stable id referenced by the control through aria-describedby. */
  errorId?: string;
}

export function Field({
  label,
  children,
  htmlFor,
  required = false,
  hint,
  error,
  className,
  errorId,
}: FieldProps) {
  const labelContent = (
    <>
      {label}
      {required ? (
        <>
          {" "}
          <span className="text-status-error-text" aria-hidden>
            *
          </span>
        </>
      ) : null}
      {hint ? <span className="ml-1.5 text-2xs font-normal text-muted">{hint}</span> : null}
    </>
  );

  return (
    <div className={cn("block", className)}>
      {htmlFor ? (
        <label htmlFor={htmlFor} className="mb-1.5 block text-xs font-medium text-secondary">
          {labelContent}
        </label>
      ) : (
        <div className="mb-1.5 text-xs font-medium text-secondary">{labelContent}</div>
      )}
      {children}
      {error ? <p id={errorId} role="alert" className="mt-1 text-xs text-status-error-text">{error}</p> : null}
    </div>
  );
}